export default "__VITE_ASSET__25d5935d__"